// Resolves the ids of teams the given user is currently a member of, by parsing
// team_users.Users in JS — the JSON/list SQL functions needed to do this in the
// database are unavailable or unreliable in duckdb-wasm
const cache = new Map();

export const getCurrentUserTeamIds = (conn, userId) => {
  const key = String(userId);
  if (!cache.has(key)) {
    cache.set(key, (async () => {
      const result = await conn.query('SELECT Id, Users FROM team_users');
      const ids = [];
      result.toArray().forEach(row => {
        const team = row.toJSON();
        let users = team.Users || team.users || [];
        if (typeof users === 'string') {
          try { users = JSON.parse(users); } catch { users = []; }
        }
        if (users && typeof users.toArray === 'function') {
          users = users.toArray().map(u => (typeof u.toJSON === 'function' ? u.toJSON() : u));
        }
        const isMember = Array.isArray(users) && users.some(
          u => (u.Id || u.id) === userId && (u.Current ?? u.current) === true
        );
        if (isMember) {
          ids.push(team.Id || team.id);
        }
      });
      return ids;
    })());
  }
  return cache.get(key);
};

// Renders an id array as a quoted, escaped SQL IN-list (never empty)
export const toSqlIdList = (ids) =>
  ids.length ? ids.map(id => `'${String(id).replace(/'/g, "''")}'`).join(',') : "''";
